import type { AppScope } from './appScope.types';
import { appScopeFromRouteParams } from './appScopeFromRouteParams';
import { resolveSettingsAppScopeFromPathname } from './resolveSettingsAppScopeFromPathname';
import {
  teamSlugFromEnterprisePath,
  workspaceSlugFromEnterprisePath
} from './resolveWorkspaceSlugForLinks';

/**
 * Slug AppScope from pathname alone (no react-router params).
 * For global chrome outside RouteAppScopeProvider (e.g. CommandBar).
 */
export function appScopeFromPathname(
  pathname: string,
  organizationId: string
): AppScope {
  const settingsScope = resolveSettingsAppScopeFromPathname(
    pathname,
    organizationId
  );
  if (settingsScope) {
    return settingsScope;
  }

  const workspaceId = workspaceSlugFromEnterprisePath(pathname);
  const teamId = teamSlugFromEnterprisePath(pathname);

  return appScopeFromRouteParams({ workspaceId, teamId }, organizationId);
}
